import * as React from 'react';
import {Typography} from '@mui/material';
import ProductsNotInMarket from './ProductsNotInMarket';
import ProductsInMarket from './ProductsInMarket';
import BusinessModelImproved from './BusinessModelImproved';
import BookkeepingImprovement from './BookkeepingImprovement';
import ExternalFunding from './ExternalFunding';
import NewSalesChannels from './NewSalesChannels';
import StartedSell from './StartedSell';
import TypeOfChannels from './TypeOfChannels';
import IncreasedCustomerNetwork from './IncreasedCustomerNetwork';
import BusinessImpact from './BusinessImpact';
import TypeOfMeasures from './TypeOfMeasures';
import getValidSubmissions from '../helpers/getValidSubmissions';
import ObtainedFunds from '@/containers/E4ImpactMBA/MidTerm/ObtainedFunds';
import ReasonOfFailure from '@/containers/E4ImpactMBA/MidTerm/ReasonOfFailure';
import MainReasonOfFailure from '@/containers/E4ImpactMBA/MidTerm/MainReasonOfFailure';
import RequestedFunds from '@/containers/E4ImpactMBA/MidTerm/RequestedFunds';
import KindOfFunds from '@/containers/E4ImpactMBA/MidTerm/KindOfFunds';
import EntrepreneursObtainedFunds from '@/containers/E4ImpactMBA/MidTerm/EntrepreneursObtainedFunds';
import PieEntrepreneursObtainedFunds from '@/containers/E4ImpactMBA/MidTerm/PieEntrepreneursObtainedFunds';
import TotalObtainedFunds from '@/containers/E4ImpactMBA/MidTerm/TotalObtainedFunds';
import ProgramContribution from '@/containers/E4ImpactMBA/MidTerm/ProgramContribution ';
import MainFailureFactors from '@/containers/E4ImpactMBA/MidTerm/MainFailureFactors';
import MainSuccessFactors from '@/containers/E4ImpactMBA/MidTerm/MainSuccessFactors';

interface IMidTermProps {
    final: any[];
    baseline: any[];
}

const MidTerm = ({final, baseline}: IMidTermProps) => {
    const {filteredBaseline} = getValidSubmissions(baseline, final);

    return (
        <div>
            <Typography variant='h5'>BUSINESS PERFORMANCE OF ESTABLISHED BUSINESSES</Typography>
            <br />
            <Typography variant='h6'>Market entry</Typography>
            <div className='row'>
                <div>
                    <ProductsNotInMarket baseline={baseline} />
                </div>
                <div>
                    <ProductsInMarket final={final} baseline={baseline} />
                </div>
            </div>
            <br />
            <Typography variant='h5'>BUSINESS MODEL</Typography>
            <br />
            <BusinessModelImproved final={final} />
            <br />
            <Typography variant='h5'>Bookkeeping improvement</Typography>
            <br />
            <BookkeepingImprovement baseline={baseline} final={final} />
            <br />
            <div className='row'>
                <div>
                    <NewSalesChannels final={final} />
                </div>
                <div>
                    <TypeOfChannels final={final} />
                </div>
            </div>
            <br />
            <Typography variant='h5'>BUSINESS PERFORMANCE OF NEW BUSINESSES (STARTED AS A BUSINESS IDEA)</Typography>
            <br />
            <Typography variant='h6'>Market entry</Typography>
            <StartedSell baseline={filteredBaseline} final={final} />
            <br />
            <Typography variant='h5'>BUSINESS PERFORMANCE OF BOTH ESTABLISHED AND NEW BUSINESSES</Typography>
            <Typography variant='h6'>Funds raised before</Typography>
            <div className='row'>
                <div>
                    <ExternalFunding baseline={baseline} />
                </div>
                <div>
                    <ReasonOfFailure baseline={baseline} />
                </div>
            </div>
            <br />
            <div className='row'>
                <div>
                    <ObtainedFunds baseline={baseline} />
                </div>
                <div>
                    <MainReasonOfFailure baseline={baseline} />
                </div>
            </div>
            <br />
            <Typography variant='h6'>Funds raised during the program</Typography>
            <div className='row'>
                <div>
                    <RequestedFunds final={final} />
                </div>
                <div>
                    <KindOfFunds final={final} />
                </div>
            </div>
            <br />
            <div className='row'>
                <div>
                    <PieEntrepreneursObtainedFunds final={final} />
                </div>
                <div>
                    <EntrepreneursObtainedFunds final={final} />
                </div>
            </div>
            <br />
            <TotalObtainedFunds final={final} />
            <br />
            <div>
                <MainSuccessFactors final={final} />
            </div>
            <br />
            <div className='row'>
                <div>
                    <ProgramContribution final={final} />
                </div>
                <div>
                    <MainFailureFactors final={final} />
                </div>
            </div>
            <br />
            <IncreasedCustomerNetwork final={final} />
            <br />
            <BusinessImpact final={final} />
            <br />
            <TypeOfMeasures final={final} />
        </div>
    );
};

export default MidTerm;
